import React from "react";

import { truncatedBodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  return (
    <div style={truncatedBodyTextStyle}>
      {node.twilio_template?.template?.length ? (
        node.twilio_template.template
      ) : "Build your SMS message"}
    </div>
  );
};
